export default {
  modalId: {
    type: String,
    requried: true,
  },
}



// WEBPACK FOOTER //
// ./src/utils/propsModalId.js